import { useEffect, useState } from 'react';
import { SelectField } from '../../common/FormFields';
import { Formik } from 'formik';
import { Button, Form } from 'semantic-ui-react';
import * as actions from '../../../redux/actions';
import * as selectors from '../../../redux/selectors';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as moment from 'moment';

const MyInvoiceSearchForm = ({ sites, searchInvoices, getSites }) => {
  const initialValues = {
    siteId: '',
    month: moment().month(),
    year: moment().year(),
  };

  const [years, setYears] = useState([]);

  useEffect(() => {
    const currentYear = 2020;
    const startYear = currentYear;

    const temp = [];

    for (let index = 0; index < 10; index++) {
      temp.push(startYear + index);
    }

    const options = temp.map((year, idx) => ({
      id: idx,
      value: year,
      text: year,
    }));

    setYears(options);
  }, []);

  const months = [
    'All',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'August',
    'September',
    'October',
    'November',
    'December',
  ].map((key, idx) => ({
    id: idx,
    value: idx,
    text: key,
  }));

  const clearSearch = formik => {
    formik.resetForm();
    searchInvoices({});
  };

  return (
    <Formik initialValues={initialValues} onSubmit={searchInvoices}>
      {formik => (
        <Form className="adslot-search-form" onSubmit={formik.handleSubmit}>
          <SelectField
            name="siteId"
            options={[{ key: 'All', value: 'All', text: 'All' }, ...sites.filter(s => s.text?.length > 1)]}
            label="Site"
            onChange={formik.handleChange}
            value={formik.values.siteId}
            formik={formik}
          />
          <SelectField
            name="month"
            options={months}
            label="Month"
            onChange={formik.handleChange}
            value={formik.values.month}
            formik={formik}
          />
          <SelectField
            name="year"
            options={years}
            label="Year"
            onChange={formik.handleChange}
            value={formik.values.year}
            formik={formik}
          />
          <Button content="Search" type="submit" fluid positive />
          <br />
          <Button content="Clear Search" onClick={() => clearSearch(formik)} fluid />
        </Form>
      )}
    </Formik>
  );
};

const mapStateToProps = state => ({
  sites: selectors.admin.siteOptionsDetail(state),
  users: selectors.getUserOptions(state),
});

const mapDispatchToProps = dispatch => ({
  searchInvoices: bindActionCreators(actions.invoices.searchInvoices, dispatch),
  getSites: bindActionCreators(actions.admin.getSites, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyInvoiceSearchForm);
